exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".ServiceDocumentation{\r\n    background-color: #e5eaf0;\r\n    border-bottom: 1px solid darkgray;\r\n}\r\n\r\n.flexItem{\r\n    flex-grow: 1;\r\n}\r\n\r\n.nestedFlexContainer{\r\n    display: flex;\r\n}", ""]);

// exports
